import $ from 'jquery'
import { Core, bp } from './core'
import 'slick-carousel'

export class Slider {
  constructor () {
    this.$body = $('body')
    this.currentBp = Core.getCurrentBp()
    this.bpMobile = bp.md
    this.bpDesktop = 99999

    this.init()

    $(document).ajaxComplete(this.init.bind(this))
    $(window).on('resize', this.reinit.bind(this))
  }

  init () {
    $('[data-slider]:not(.slick-initialized)').each(this.generateSlider.bind(this))
  }

  reinit () {
    let newBp = Core.getCurrentBp()

    if (this.currentBp !== newBp) {
      this.currentBp = Core.getCurrentBp()
      this.init()
    }
  }

  generateSlider (index, slider) {
    let $slider = $(slider)
    let args = this.generateArgs($slider)

    if (args) {
      $slider.slick(args)
      this.loadSlideIndexAuto($slider)
    }
  }

  loadSlideIndexAuto ($slider) {
    let hash = window.location.hash
    if (hash !== '' && hash.length) {
      // The 'slick-slide' div has to own a data-attribute <div class="item" data-hash="#hash1">
      // Find the slide that have the correct data-hash
      // var correctSlide = $slider.find('[data-hash="' + hash + '"]:not(.slick-cloned)');
      //
      // // Check the data-slick-index to proprely use it in the 'gotoSlide' method
      // var gotoSlide = correctSlide.data('slick-index');
      //
      // console.log('Going to silde number ' + gotoSlide);
      //
      // $slider.slick('slickGoTo', gotoSlide);
    }
  }

  generateArgs ($slider) {
    let data = $slider.data('slider')

    if (data.mobile === false && data.desktop === false) {
      return false
    }

    /**
     * Ajout des classes couleurs pour les dots/arrows
     */
    if (data.mobile.controlColor) {
      $slider.addClass(`control-mobile-${data.mobile.controlColor.replace('bg-', '')}`)
      delete data.mobile.controlColor
    }

    if (data.desktop.controlColor) {
      $slider.addClass(`control-${data.desktop.controlColor.replace('bg-', '')}`)
      delete data.desktop.controlColor
    }

    /**
     * Création des args de Slick
     */
    let args = {
      lazyLoad: 'ondemand',
      infinite: false,
      responsive: []
    }

    let breakpoint = this.bpMobile

    if (typeof data.bp != 'undefined' && Object.keys(bp).includes(data.bp)) {
      breakpoint = bp[data.bp]
    }

    args.responsive.push({
      breakpoint: breakpoint,
      settings: data.mobile ? data.mobile : 'unslick'
    })

    args.responsive.push({
      breakpoint: this.bpDesktop,
      settings: data.desktop ? data.desktop : 'unslick'
    })

    if (data.mobile.arrows || data.desktop.arrows) {
      args.prevArrow = '<div class="slick-arrow slick-prev"><i class="icon icon-arrow-left"></i></div>'
      args.nextArrow = '<div class="slick-arrow slick-next"><i class="icon icon-arrow-right"></i></div>'
    }

    return args
  }
}
